import { render, staticRenderFns } from "./FloatingBottomBar.vue?vue&type=template&id=fee228a0&scoped=true"
import script from "./FloatingBottomBar.vue?vue&type=script&lang=ts"
export * from "./FloatingBottomBar.vue?vue&type=script&lang=ts"
import style0 from "./FloatingBottomBar.vue?vue&type=style&index=0&id=fee228a0&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fee228a0",
  null
  
)

export default component.exports